/**
 * Runtime accessors for the CSS-variable-driven design tokens.
 *
 * Prefer Tailwind classes (`bg-accent`, `text-success`, etc.) over these where
 * possible. Use these only when a value must be pushed into a non-CSS API —
 * e.g. Recharts stroke colors, Framer Motion `animate` props, or a plain SVG
 * `stroke=` attribute.
 *
 * Reads from `document.documentElement` at call time, so any theme swap made
 * via the DevTools style panel (or a future runtime theme switcher) is picked
 * up on the next call.
 */

const readVar = (name, fallback) => {
  if (typeof document === "undefined") return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name);
  return (v || "").trim() || fallback;
};

export const getThemeAccent       = () => readVar("--color-accent",       "#2ECC71");
export const getThemeAccentLight  = () => readVar("--color-accent-light", "#58D68D");
export const getThemeAccentDark   = () => readVar("--color-accent-dark",  "#27AE60");
export const getThemeAccentMuted  = () => readVar("--color-accent-muted", "rgba(46, 204, 113, 0.20)");
export const getThemeAccentGlow   = () => readVar("--color-accent-glow",  "rgba(46, 204, 113, 0.30)");
export const getThemeSuccess      = () => readVar("--color-success",      "#27AE60");

// Convenience frozen snapshot (evaluated at import time). Prefer the fn form
// if you expect the theme to change mid-session.
export const THEME_ACCENT       = getThemeAccent();
export const THEME_ACCENT_LIGHT = getThemeAccentLight();
export const THEME_ACCENT_DARK  = getThemeAccentDark();
export const THEME_SUCCESS      = getThemeSuccess();
